import Text from 'fe-design-base/atoms/Text';

const SkipAddMemberToTeamModal = () => (
  <>
    <Text
      variant="body"
      color="mono900"
      i18n="hiring.dashboard.v2.interview.to_review.follow_up.skip_add_member_to_team_modal_text"
    />
  </>
);

export default SkipAddMemberToTeamModal;
